import { inject, Injectable, Type } from '@angular/core';
import { DynamicDialogEscapeStack } from '@common/shortcuts/dynamic-dialog-escape-stack';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable()
export class EscapableDialogService extends DialogService {
  private readonly escapeStack = inject(DynamicDialogEscapeStack);

  override open<T, DataType = any, InputValuesType extends Record<string, any> = {}>(
    componentType: Type<T>,
    config: DynamicDialogConfig<DataType, InputValuesType>,
  ): DynamicDialogRef<T> | null {
    const ref = super.open(componentType, config);
    if (ref === null || !this.needsEscapeHandling(config)) return ref;
    const host = this.dialogComponentRefMap.get(ref)?.location.nativeElement as HTMLElement | undefined;
    if (host !== undefined) this.escapeStack.register(ref, host);
    return ref;
  }

  private needsEscapeHandling(config: DynamicDialogConfig): boolean {
    return config.closable === undefined && config.closeOnEscape === undefined;
  }
}
